module.exports = __webpack_public_path__ + "assets/img/tedian2.b3eb33ee.png";